<template>
  <div class="globalModal-wrap" v-loading="dataLoading">
    <div class="globalModal">
      <h2 class="modal-title" v-if="!isConfirmed">Change of Contracting Party Confirmation</h2>
      <div v-if="!isConfirmed" class="agreement-flow">
        <div class="test">
          <div class="merchant-info-container">
            <div class="merchant-info">
              <div class="info-row">
                <div class="info-key">Merchant ID: </div>
                <div class="info-value">{{ app.businessTypes.merchantNo }}</div>
              </div>
              <div class="info-row">
                <div class="info-key">Merchant Name: </div>
                <div class="info-value">{{ app.businessTypes.merchantName || '--' }}</div>
              </div>
            </div>
            <div class="agreement-section">
              <div class="agreement-container">
                <h3 class="agreement-title">Agreement Change Notice</h3>
                <div class="agreement-content" ref="agreementContent">
                  <p>Please carefully read all the terms of this Agreement before you click to agree to this Agreement.
                    By
                    clicking "I have read and agreed to the Agreement", the Merchant (defined below) represents and
                    warrants that it understands all the terms of this Agreement and agrees to enter into this Agreement
                    by electronic means.</p>
                  <p>If you do not agree with or do not understand the terms of this Agreement, please do not click "I
                    have read and agreed to the Agreement". You can contact Onerway customer service if you have any
                    questions relating to this Agreement.</p>
                  <p>By clicking "Agree", you will be automatically deemed as the authorized representative/ director of
                    Merchant. In case your account has been accessed without authorization, please contact us
                    immediately.
                  </p>
                  <div v-if="showFullAgreement" class="full-agreement">
                    <word></word>
                  </div>
                  <a href="javascript:;" class="view-agreement" @click="toggleFullAgreement">
                    {{ showFullAgreement ? 'Hide full agreement' : 'View full agreement' }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="agreement-actions">
          <div class="agreement-checkbox" :class="{ 'error': showError }">
            <input type="checkbox" id="agreeCheckbox" v-model="agreedToTerms" @change="clearError">
            <label for="agreeCheckbox">I have read and understood all terms of the "Agreement for Change of Contracting
              Party" and agree to change the contracting entity for payment services.</label>
          </div>
          <div class="action-buttons confirm-actions">
            <button class="confirm-button" @click="confirmAgreement">Confirm and Agree</button>
          </div>
        </div>
      </div>
      <div v-else class="confirmation-success">
        <div class="success-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#00C853" />
            <path d="M20 30.7L13.3 24L11 26.3L20 35.3L38 17.3L35.7 15L20 30.7Z" fill="white" />
          </svg>
        </div>
        <h3>Thank you for your confirmation!</h3>
        <p>You have successfully confirmed the Change of Contracting Party Agreement.<br>We will officially switch your
          contracting entity in 30 days.</p>
        <div class="confirmation-details">
          <h4>Confirmation Details</h4>
          <div class="details-grid">
            <div class="detail-row">
              <div class="detail-label">Merchant ID</div>
              <div class="detail-value">{{ confirmationData && confirmationData.merchantNo || '--' }}</div>
              <div class="detail-label">Merchant Name</div>
              <div class="detail-value">{{ confirmationData && confirmationData.merchantName || '--' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Confirmation Time</div>
              <div class="detail-value">{{ confirmationData && confirmationData.createTime || '--' }}</div>
              <div class="detail-label">IP Address</div>
              <div class="detail-value">{{ confirmationData && confirmationData.ip || '--' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Agreement Version</div>
              <div class="detail-value">{{ confirmationData && confirmationData.contractVersion || '--' }}</div>
              <div class="detail-label">Reference No</div>
              <div class="detail-value">{{ confirmationData && confirmationData.confirmNo || '--' }}</div>
            </div>
          </div>
        </div>
        <div class="confirmation-actions">
          <div class="divider"></div>
          <div class="action-buttons">
            <button class="download-button" @click="downloadTerms">View full standard terms in PDF file</button>
            <button class="return-button" @click="returnToHomepage">Return to Homepage</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { confirmResigning } from '@/api/common';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import { formatDateDisplay } from '@/utils/tools/time';
import { setLocalStorage } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';

import word from './word.vue';
export default {
  name: 'GlobalModal',
  props: {
    /**
     * 模版
     */
  },
  components: {
    word,
  },
  data() {
    return {
      dataLoading: false,
      agreedToTerms: false,
      showError: false,
      showToast: false,
      showFullAgreement: false,
      isConfirmed: false,
      newBusinessTypes: null,
      // 接口数据
      confirmationData: {
        // merchantId: 'Auto initiated',
        // merchantName: 'www.123.com',
        // confirmationTime: '2025-05-08T20:12:00Z',
        // ipAddress: '123.123.123.123123.123.123.11',
        // agreementVersion: 'Standard Terms Version V20241',
        // referenceNo: 'MEETSOCIAL (HONGKONG) DIGITAL MARKETING CO., LIMITED',
      },
    };
  },

  mounted() {
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  methods: {
    toggleFullAgreement() {
      this.showFullAgreement = !this.showFullAgreement;
    },
    clearError() {
      this.showError = false;
    },
    // 获取用户时区
    getUserTimezone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    // 将时间转换为GMT格式
    formatToGMT(dateTimeStr) {
      if (!dateTimeStr) return '--';
      try {
        console.log('Input dateTimeStr:', dateTimeStr);
        // 创建日期对象
        const date = new Date(dateTimeStr);
        console.log('Created date object:', date);
        // 检查日期是否有效
        if (isNaN(date.getTime())) {
          console.log('Invalid date detected');
          return dateTimeStr;
        }
        // 先减去8小时
        const adjustedDate = new Date(date.getTime() - 8 * 60 * 60 * 1000);
        // console.log('Date after -8 hours adjustment:', adjustedDate);
        // 获取用户本地时区的偏移量（分钟）
        const userTimezoneOffset = adjustedDate.getTimezoneOffset();
        // console.log('userTimezoneOffset:', userTimezoneOffset);
        // 转换为GMT格式的字符串，格式为：YYYY-MM-DD HH:MM:SS GMT+/-HHMM
        const gmtDate = new Date(adjustedDate.getTime() - userTimezoneOffset * 60000);
        // console.log('gmtDate:', gmtDate);
        const formattedDate = formatDateDisplay(gmtDate, 'yyyy-MM-dd HH:mm:ss');
        // console.log('formattedDate:', formattedDate);
        // 计算时区偏移的小时和分钟
        const offsetHours = Math.abs(Math.floor(userTimezoneOffset / 60));
        // console.log('offsetHours:', offsetHours);
        const offsetMinutes = Math.abs(userTimezoneOffset % 60);
        // console.log('offsetMinutes:', offsetMinutes);
        const offsetSign = userTimezoneOffset > 0 ? '-' : '+';
        // console.log('offsetSign:', offsetSign);
        // 拼接时区信息，格式为GMT+08:00
        const offsetStr = `GMT${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;
        // console.log('offsetStr:', offsetStr);
        const result = `${formattedDate} ${offsetStr}`;
        // console.log('Final result:', result);
        return result;
      } catch (error) {
        // console.error('Error formatting date to GMT:', error);
        return dateTimeStr || '--';
      }
    },
    async confirmAgreement() {
      if (!this.agreedToTerms) {
        this.showError = true;
        // this.showToast = true;
        ShowErrorMessage('Please check the box to agree to the terms.');

        setTimeout(() => {
          this.showToast = false;
        }, 3000);
        return;
      }
      this.dataLoading = true;
      // this.isConfirmed = true;
      try {
        const res = await confirmResigning();
        console.log('res', res);

        if (res) {
          // 处理createTime字段，转换为用户时区的GMT格式
          if (res.createTime) {
            res.createTime = this.formatToGMT(res.createTime);
          }

          this.confirmationData = res;
          this.dataLoading = false;
          this.isConfirmed = true;
          const res2 = await AccountInfo.getAccountInfo();
          if (res2) {
            this.newBusinessTypes = res2;
          }
        }
      } catch (error) {
        console.error('Error confirming agreement:', error);
        // ShowErrorMessage(error);
      } finally {
        this.dataLoading = false;
      }
    },
    downloadTerms() {
      // 实现下载标准条款的功能
      const pdfUrl = '/static/files/Merchant Service Standard Terms.pdf';
      window.open(pdfUrl, '_blank');
    },
    async returnToHomepage() {
      this.dataLoading = true;
      await this.$store.dispatch('app/setBusinessTypes', this.newBusinessTypes);
      setLocalStorage('BusinessTypes', JSON.stringify(this.newBusinessTypes));

      this.dataLoading = false;
      if (this.$route.path !== '/index') {
        this.$router.replace({
          path: '/index',
        });
        setTimeout(() => {
          this.$emit('close');
        }, 200);
      } else {
        // window.location.reload();
        // 可能需要关闭模态框
        setTimeout(() => {
          this.$emit('close');
        }, 200);
      }
    },
    // },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.globalModal-wrap {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 9999;
  left: 0;

  .globalModal {
    width: 852px;
    // height: 686px;
    background: #FFFFFF;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #EFEFF4;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    padding: 32px;
    box-sizing: border-box;
    overflow: hidden;

    .modal-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 0 24px;
      color: #333;
    }

    .agreement-flow {
      display: flex;
      flex-direction: column;
      height: calc(100% - 80px);
      /* 扣除标题和内边距的高度 */
    }

    .merchant-info-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-bottom: 12px;
      height: 481px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #EFEFF4;
      padding: 24px;
      box-sizing: border-box;
    }

    .merchant-info {
      display: flex;
      // background: #F8F8F8;
      // padding: 16px;
      // border-radius: 8px;
      box-sizing: border-box;
      margin-bottom: 24px;

      .info-row {
        flex: 1;
        display: flex;
        align-items: center;

        .info-key {
          color: #888;
          font-size: 14px;
          font-weight: normal;
          // margin-right: 16px;
          //min-width: 120px;
        }

        .info-value {
          font-size: 14px;
          font-weight: 500;
          flex: 1;
          margin-left: 4px;
        }
      }
    }

    .agreement-section {
      height: 400px;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      &::-webkit-scrollbar {
        display: none; // 完全隐藏滚动条
      }

      .agreement-container {
        background: #F8F8F8;
        border-radius: 8px;
        // border: 1px solid #E0E0E0;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding: 24px;
        box-sizing: border-box;
      }

      .agreement-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 24px;
        color: #1A202C;
        // padding: 16px 16px 0;
      }

      .agreement-content {
        // padding: 16px;
        flex: 1;
        overflow-y: auto;
        position: relative;

        // 自定义滚动条样式 - 完全透明
        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.1);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }

        // 核心技巧：创建伪元素遮罩，覆盖在内容区域上，将滚动条"推"向右侧
        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 10px; // 滚动条偏移量
          height: 100%;
          z-index: 10;
          // 设置为透明，不会影响视觉效果
          background-color: transparent;
          // 关键属性：让鼠标事件穿透此元素
          pointer-events: none;
        }

        p {
          font-weight: 400;
          font-size: 16px;
          color: #1A202C;
          line-height: 22px;
          margin-bottom: 16px;
        }

        .full-agreement {
          // margin-top: 16px;
          // padding-top: 16px;
          // border-top: 1px solid #E0E0E0;
        }

        .view-agreement {
          color: #0066CC;
          text-decoration: none;
          font-weight: 500;
          display: inline-block;
          // margin-top: 8px;
          text-decoration: underline;

          &:hover {
            color: #00A2DD;
          }
        }
      }
    }

    .agreement-actions {
      margin-top: auto;

      .agreement-checkbox {
        display: flex;
        align-items: flex-start;
        margin-bottom: 24px;

        input[type="checkbox"] {
          background-color: #00a2dd;
          --checkbox-check-color: white;
          /* 在支持的浏览器中可能生效 */

        }

        input {
          margin-top: 3px;
          color: white;
          margin-right: 8px;
        }

        label {
          font-size: 14px;
          line-height: 1.5;
          color: #888;
        }

        &.error {
          label {
            color: #f44336;
          }
        }
      }
    }

    .action-buttons {
      display: flex;
      justify-content: flex-end;
      gap: 16px;

      &.confirm-actions {
        justify-content: flex-end;
      }

      button {
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        color: #FFFFFF;
        transition: background-color 0.2s;
      }

      .confirm-button {
        // background-color: #5E35B1;
        background-color: #00a2dd;
        border-color: #00a2dd;
        color: white;
        border: none;
        // min-width: 200px;

        &:hover {
          // background-color: #4527A0;
        }
      }

      .download-button {
        background-color: white;
        color: #333;
        border: 1px solid #E0E0E0;

        &:hover {
          background-color: #F5F5F5;
        }
      }

      .return-button {
        background-color: #00a2dd;
        border: none;

        &:hover {
          // background-color: #4527A0;
        }
      }
    }

    .confirmation-success {
      text-align: center;
      padding: 24px 0;

      .success-icon {
        margin-bottom: 16px;
      }

      h3 {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      p {
        color: #666;
        margin-bottom: 32px;
      }

      .confirmation-details {
        background: #F8F8F8;
        border-radius: 8px;
        padding: 20px;
        text-align: left;
        margin-bottom: 32px;

        h4 {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 16px;
        }

        .details-grid {
          .detail-row {
            display: grid;
            grid-template-columns: 120px 1fr 120px 1fr;
            gap: 16px;
            margin-bottom: 16px;

            .detail-label {
              color: #888;
              font-size: 14px;
            }

            .detail-value {
              font-size: 14px;
              font-weight: 500;
              max-width: 208px;
              word-break: break-word;
            }
          }
        }
      }

      .confirmation-actions {
        margin-top: 24px;

        .divider {
          height: 1px;
          background-color: #E0E0E0;
          width: 100%;
          margin-bottom: 24px;
        }

        .action-buttons {
          display: flex;
          justify-content: flex-end;
          gap: 16px;
        }
      }
    }

    .toast-message {
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: white;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 12px 16px;
      z-index: 10001;

      .toast-content {
        display: flex;
        align-items: center;

        .toast-icon {
          margin-right: 8px;
        }

        .toast-close {
          margin-left: 16px;
          cursor: pointer;
          font-size: 18px;
        }
      }
    }
  }
}

.el-message {
  z-index: 10000 !important;
  /* 确保比你的modal的z-index高 */
}

/* 方案：RTL与LTR混合排版控制滚动条位置 */

.scroll-container {
  /* 关键1: 使用RTL文本方向，让滚动条默认出现在左侧 */
  direction: rtl;
  /* 关键2: 添加足够的左边距，让滚动条位置向右偏移 */
  margin-left: 30px;
}

.scroll-container>* {
  /* 关键3: 内容仍然保持LTR方向显示 */
  direction: ltr;
}
</style>
